import { render, staticRenderFns } from "./SubTable.vue?vue&type=template&id=2b7745d0&scoped=true&slot-scope=props&"
import script from "./SubTable.vue?vue&type=script&lang=ts&"
export * from "./SubTable.vue?vue&type=script&lang=ts&"
import style0 from "./SubTable.vue?vue&type=style&index=0&id=2b7745d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7745d0",
  null
  
)

export default component.exports